// 9-tab strip stub for the contact record.
//
// Tab order is fixed and must match the walkthrough decision doc.
// Current action, Build an order, Horses, Subscription, Gifts,
// Colic Coverage, Relationships, Service needs, History.
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

export interface TabDefinition {
  slug: string;
  label: string;
}

export const CONTACT_TABS: readonly TabDefinition[] = Object.freeze([
  { slug: 'current', label: 'Current action' },
  { slug: 'build-order', label: 'Build an order' },
  { slug: 'horses', label: 'Horses' },
  { slug: 'subscription', label: 'Subscription' },
  { slug: 'gifts', label: 'Gifts' },
  { slug: 'colic-coverage', label: 'Colic Coverage' },
  { slug: 'relationships', label: 'Relationships' },
  { slug: 'service-needs', label: 'Service needs' },
  { slug: 'history', label: 'History' },
]);

export interface TabStripProps {
  contactId: string;
}

export function TabStrip({ contactId }: TabStripProps): ReactNode {
  return (
    <div
      role="tablist"
      aria-label="Contact workspace tabs"
      style={{
        display: 'flex',
        gap: 4,
        borderBottom: '1px solid #d0d0d0',
        padding: '0 12px',
        overflowX: 'auto',
      }}
    >
      {CONTACT_TABS.map((tab) => (
        <NavLink
          key={tab.slug}
          role="tab"
          to={`/contacts/${contactId}/${tab.slug}`}
          style={({ isActive }) => ({
            padding: '10px 14px',
            borderBottom: isActive ? '2px solid #111' : '2px solid transparent',
            textDecoration: 'none',
            color: '#111',
            fontWeight: isActive ? 600 : 400,
            whiteSpace: 'nowrap',
          })}
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}
